import { useMemo } from 'react';

import { getReactExtensions } from '@/components/PageEditor/Extensions';
import getEditorSchema from '@/components/PageEditor/schema';
import { useAppConfig } from '@/hooks/useAppConfig';

import { FeatureFlags, useFeatureFlags } from '../../../../../helper/FeatureFlags';
import { CourseLessonPage } from '../Extensions/@ly';

const useCourseEditorViewProps = () => {
  const appConfig = useAppConfig();
  const {
    [FeatureFlags.DefaultRestricted]: isDefaultRestricted,
    [FeatureFlags.EnableAIVideoGeneration]: isAiVideoGenerationEnabled,
    [FeatureFlags.EnableRoleplay]: isRoleplayEnabled,
  } = useFeatureFlags();
  return useMemo(() => {
    const editorSchema = getEditorSchema(
      [
        CourseLessonPage,
        ...getReactExtensions({
          scormEnabled: appConfig.ui.showImportCreateBtn,
          isAiVideoGenerationEnabled,
          isRoleplayEnabled,
        }),
      ],
      { isDefaultRestricted },
    );
    return editorSchema;
  }, [
    appConfig.ui.showImportCreateBtn,
    isAiVideoGenerationEnabled,
    isDefaultRestricted,
    isRoleplayEnabled,
  ]);
};
export default useCourseEditorViewProps;
